export default "__VITE_ASSET__dKdef4DK__"